import Orders from "@/pages/app/Orders";

export default function MenuItems() {
  return (
    <Orders
      initialTab="calendar"
      hideTabs
      headerTitle="Menu Items"
      headerDescription="Create weekly menus and meals, then generate share links"
    />
  );
}

